import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IUserInactivity } from '@core/models/modals';
import {
  AnalyticsService,
  ReqService,
  SearchStateService,
  URLService,
} from '@core/services';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';
import {
  MB_DIALOG_DATA,
  MbDialogRef,
  MbDialogFooter,
  MbDialogBody,
  MbStarsRating,
  MbIcon,
  MbTooltipTrigger,
  MbAdvice,
  MbButton,
  MbDialogHeader,
} from '@am/moebius';

@Component({
  selector: 'app-modal-user-inactivity',
  standalone: true,
  imports: [
    CommonModule,
    MbDialogHeader,
    MbDialogBody,
    MbStarsRating,
    MbIcon,
    MbTooltipTrigger,
    MbAdvice,
    MbButton,
  ],
  templateUrl: './user-inactivity.component.html',
  styleUrls: ['./user-inactivity.component.scss'],
})
export class ModalUserInactivityComponent
  extends DialogWrapperComponent
  implements OnInit
{
  public urlResize;
  public brandImage: string;
  private brandImages: Array<string> = ['avantrip'];

  constructor(
    private searchStateService: SearchStateService,
    private analyticsService: AnalyticsService,
    private urlService: URLService,
    private dialogRef: MbDialogRef<ModalUserInactivityComponent>,
    @Inject(MB_DIALOG_DATA) public dialogData: IUserInactivity,
    private readonly contextService: ReqService,
  ) {
    super();
  }

  ngOnInit() {
    if (this.brandImages.includes(this.contextService.getBrand())) {
      this.brandImage = `${this.contextService.getBrand()}-image`;
    } else {
      this.brandImage = 'almundo-image';
    }
    super.ngOnInit();
    this.urlResize = this.urlService.getResizeUrl('', 'result');
  }

  public goToDetail() {
    this.analyticsService.trackEvent({
      section: 'Results',
      action: 'User Inactivity',
      label: 'Go To Detail',
    });

    const finalUrl: string = this.getUrl(this.dialogData.hotel);
    window.open(finalUrl, '_blank');
    this.dialogRef.close(true);
  }

  private getUrl(hotel) {
    let slugName: any = hotel.slug.split('-');
    const slugId: any = slugName.pop();
    slugName = slugName.join('-');
    let finalUrl = '';
    const query = this.searchStateService.getLocationSearch();
    const priceBy = this.searchStateService.getPriceBy()
      ? '&priceBy=' + this.searchStateService.getPriceBy()
      : '';

    let data = '';
    if (query.featuredHotelId) {
      data += '&featuredHotelId=' + query.featuredHotelId;
    }
    if (query.flexible) {
      data += '&flexible=' + query.flexible;
    }
    if (query.ratesFilterOption) {
      data += '&ratesFilterOption=' + query.ratesFilterOption;
    }
    if (query.withFullPrice) {
      data += '&withFullPrice=' + query.withFullPrice;
    }
    if (query.dynamicEnabled) {
      data += '&dynamicEnabled=' + query.dynamicEnabled;
    }
    if (query.PAYMENT_METHOD) {
      data += '&PAYMENT_METHOD=' + query.PAYMENT_METHOD;
    }
    if (query.theme) {
      data += '&theme=' + query.theme;
    }

    finalUrl =
      '/hotels/detail/' +
      slugName +
      '-' +
      this.searchStateService.getHashedId(slugId) +
      '?date=' +
      query.date +
      '&rooms=' +
      query.rooms +
      priceBy +
      data +
      '&p=' +
      this.dialogData.hotel.rate.price.x_per_night +
      '&origin=' +
      this.searchStateService.getEntityCode() +
      '&brand=' +
      this.contextService.getBrand();

    return window.location.origin + finalUrl;
  }
}
